export { default, default as PracticeInformation } from "./PracticeInformation";
